/* HB Version 1.
*  Updates: Modules are configured from the 
* */

import be from './boot-entities'
import {ajaxManagerConfig} from './configs'
import {getLS} from 'devegram-javascript-util'

const boot = (app) => {
    return new Promise(async (resolve) => {
        let router = bootGlobalData(app)
        await bootConfigs(app)
        await bootDefaultVuexModules()
        await bootUserPermissions()
        await loadRouterRoutes()
        await $store.dispatch('app-state/doneLoading')
        resolve({
            router
        })
    })
}

const bootGlobalData = (app) => {
    const globalData = {}
    let {router} = be.bindStoreAndRouter(globalData)
    be.bindWLogger(globalData)
    be.bootUILangSetting(globalData)
    be.bindXModules(globalData)
    be.bindGlobalData(app, globalData)
    return router;
}

const bootConfigs = async (app) => {
    await ajaxManagerConfig()
}

const bootDefaultVuexModules = async () => {
    return new Promise(async function (resolve) {
        $xmodule.load('user').then(async function () {
            await $xmodule.load('app')
            await $xmodule.load('side-nav')
            //await bootModules($store.state['user-state'].modules)
            resolve()
        })
    })
}


export const bootModules = async (modules) => {
    return new Promise(async function (resolve) {
        let promises = []
        let keys = Object.keys(modules)
        keys.forEach((moduleName) => {
            promises.push($xmodule.load(moduleName))
        })
        let result = await Promise.all(promises)
        resolve()
    })
}

const bootUserPermissions = () => {
    return new Promise((resolve, reject) => {
        if (getLS('user')) {
            $store.dispatch('user-api/verify', {
                onError: (error, resolve, reject) => {
                    resolve(false)
                }
            }).then((r) => {
                bootModules(r.data.modules).then(() => {
                    resolve(true)
                })
            }).catch( error  => {
                resolve(false)
            })
        } else {
            resolve(false)
        }
    })
}

const loadRouterRoutes = function () {
    return new Promise(async function (resolve, reject) {
        let l = location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '')
        let current = location.toString().replace(l, '')
        /*let currentPortal = current.split('/')[1]
        if (currentPortal.length === 0) {
          currentPortal = 'home'
          router.push('home')
        }
        let {default: portalRoutes} = await import('@/app/portals/' + currentPortal + '/routes.js')
        router.addRoutes(portalRoutes)
        */
        resolve()
    })
}

export default boot
